/* eslint-disable import/no-extraneous-dependencies */
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import PageCommonHandler from '../components/PageCommonHandler';
import DashboardSection from '../app/dashboard/DashboardSection';
import IncomeInfo from '../app/income/IncomeInfo';
import DailyExpenseInfo from '../app/expense/DailyExpenseInfo';
import LocalInvestInfo from '../app/invest/LocalInvestInfo';
import OtherInvestInfo from '../app/invest/OtherInvestInfo';
import ProfitLossDisbursementInfo from '../app/profitloss/ProfitLossDisbursementInfo';
import FinanceTransactionInfo from '../app/finance/FinanceTransactionInfo';
import FinanceAccountType from '../app/finance/FinanceAccountType';
import FinanceAccountList from '../app/finance/FinanceAccountList';
import InvestorList from '../app/investor/InvestorList';
import InvestorCollection from '../app/investor/InvestorCollection';
import MemberInfo from '../app/invest/MemberInfo';

function RouteHandler() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<PageCommonHandler />}>
                    <Route path="/" element={<DashboardSection />} />
                    <Route path="investor/list" element={<InvestorList />} />
                    <Route path="investor/collection" element={<InvestorCollection />} />
                    <Route path="income" element={<IncomeInfo />} />
                    <Route path="expense" element={<DailyExpenseInfo />} />
                    <Route path="invest/member" element={<MemberInfo />} />
                    <Route path="invest/local" element={<LocalInvestInfo />} />
                    <Route path="invest/other" element={<OtherInvestInfo />} />
                    <Route path="profit-loss/disbursement" element={<ProfitLossDisbursementInfo />} />
                    <Route path="finance/transaction" element={<FinanceTransactionInfo />} />
                    <Route path="finance/account/type" element={<FinanceAccountType />} />
                    <Route path="finance/:type/:code/account/list" element={<FinanceAccountList />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
}

export default RouteHandler;
